import request from "./request";
import {
  baseUrl
} from "@/utils/auth";
/**
 * 产品相关接口
 * @author 小圣贤君
 * @time 2020/03/12
 */
export default {

  /**
   * 获取产品信息
   */
  getProductInfo() {
    return request.get("/product/productInfo");
  }
}



// WEBPACK FOOTER //
// ./src/api/productService.js